import React from 'react';
import './AKLogo.css';

function AKLogo() {
  return <span className="ak-logo">AK</span>;
}

export default AKLogo;
